(function (upp) {
    'use strict';
    upp
        .config(['$routeProvider',
        function ($routeProvider) {

            var resolver = {
                resolve:$routeProvider.ResolverFactory.moduleIsActivated("eshop").resolver
            };
            $routeProvider
                .when('/eshop', {
                    templateUrl: require('../templates/eshop-catalog.html'),
                    resolve: resolver,
                })
                .when('/eshop/:info', {
                    templateUrl: require('../templates/eshop-product.html'),
                    resolve: resolver,
                    showAd: true
                })
            ;
        }])
    ;
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/eshop/routes/eshop-routes.js